import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../../common/Button';
import DiveMessageBanner from '../../common/DiveMessageBanner';

const DisclaimerAndSubmitButton = ({
  handleSubmitClick,
}) => {
  return (
    <>
      <div className="content-guidelines-wrapper">
        <DiveMessageBanner messageType="warning" additionalClasses="content-guidelines-banner" isClosable={false}>
          By posting to DiveWire you agree to the terms of the{' '}
          <a href="https://www.industrydive.com/divewire-content-policy/" target="_blank" rel="noopener noreferrer">
            <strong>DiveWire Content Policy.</strong>
          </a>
        </DiveMessageBanner>
      </div>
      <div className="button-container">
        <Button as="button" type="submit" onClick={handleSubmitClick}>
          Submit
        </Button>
      </div>
    </>
  );
};

DisclaimerAndSubmitButton.propTypes = {
  handleSubmitClick: PropTypes.func.isRequired,
};

export default DisclaimerAndSubmitButton;
